import CourseSkeleton from "@modules/skeleton/course_skeleton";
import CourseCard from "@modules/study/common/course_card";
import { AppBar, Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import API from "@unisearch/helpers/api";
import Link from "next/link";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { Fragment, useEffect, useState } from "react";
import styles from "./uni_overview_courses.module.scss";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: "transparent",
  },
}));

export const UniOverviewCourses = ({ universityProfileData }) => {
  const router = useRouter();
  const { query } = router;
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const [value, setValue] = useState(0);
  const [index, setIndex] = useState(0);
  const [level, setSlug] = useState("");
  const [totalCourseCounted, setTotalCourseCounted] = useState(0);
  const [courses, setCourses] = useState([]);
  const [courseLevelData, setCourseLevelData] = useState([]);
  const [loading, setLoading] = useState(false);
  const university_name = universityProfileData.universitySlug;

  const slugLink =
    level == "topcourse" || level == "" ? "sbp=1" : `crl=${level}`;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await API.get(`/public/course-level/${university_name}`).then(
        async (resp) => {
          if (!resp.error && resp.data) {
            const levels = resp.data?.filter(
              (item, i) =>
                item?.totalCourse != null && parseInt(item?.totalCourse) != 0
            );
            if (levels?.length && levels?.length > 0) {
              const levelSlug = levels[0]?.levelSlug;
              await API.get(
                `/public/university-course/${university_name}/${levelSlug}?limit=12&page=1`
              ).then((rsp) => {
                if (!rsp.error && rsp.data) {
                  setLoading(true);
                  setCourses(rsp?.data?.courseData?.results);
                  setTotalCourseCounted(rsp?.data?.courseData?.total);
                }
              });
            }
            setCourseLevelData(resp.data);
          }
        }
      );
    };
    fetchData();
  }, []);

  //end
  const filteredLevel = courseLevelData?.filter(
    (item, i) => item?.totalCourse != null && parseInt(item?.totalCourse) != 0
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //course handler
  const handleCourses = async (slug) => {
    setCourses([]);
    setLoader(true);
    await API.get(
      `/public/university-course/${query.university_name}/${slug}?limit=8&page=1`
    ).then((rsp) => {
      if (!rsp.error && rsp.data) {
        setCourses(rsp?.data?.courseData?.results);
        setTotalCourseCounted(rsp?.data?.courseData?.total);
      }
      setLoader(false);
    });
  };

  return (
    <Fragment>
      {filteredLevel && filteredLevel?.length > 0 ? (
        <section className={styles.section_courses}>
          <div className="container">
            <div className={styles.title_wrapper}>
              <h2>All Courses</h2>
              <p className={styles.short_description}>
                Explore the courses {universityProfileData?.universityName} has
                to offer to find the right program for you!
              </p>
            </div>

            <div className={styles.tabs_wrapper}>
              <div className="uni_courses">
                <div className={classes.root}>
                  <AppBar position="static" color="default">
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      indicatorColor="primary"
                      textColor="primary"
                      variant="scrollable"
                      scrollButtons
                      allowScrollButtonsMobile
                      aria-label="scrollable auto tabs example"
                    >
                      {filteredLevel?.map((level, i) => {
                        return (
                          <Tab
                            label={`${level?.levelName}`}
                            {...a11yProps(i)}
                            key={i}
                            onClick={() => {
                              setIndex(i);
                              setSlug(level.levelSlug);
                              handleCourses(level.levelSlug);
                            }}
                          />
                        );
                      })}
                    </Tabs>
                  </AppBar>

                  {loader ? (
                    <div style={{ paddingTop: "40px" }}>
                      <CourseSkeleton />
                    </div>
                  ) : (
                    <>
                      {courses && courses?.length > 0 && (
                        <TabPanel value={value} index={index}>
                          <Grid
                            container
                            spacing={{ xs: 2, sm: 2, md: 3 }}
                            justifyContent="center"
                          >
                            {courses.map((course, i) => (
                              <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                                <CourseCard
                                  link={`/study/${query.country_name}/university/${query.university_name}/${course?.courseSlug}`}
                                  name={course?.courseName}
                                  level={course?.courseLevel}
                                  session={course?.sessionName}
                                  duration={course?.courseDuration}
                                  intakes={course?.intakes}
                                  amountFrom={course?.feesAmountFrom}
                                  amountTo={course?.feesAmountTo}
                                  countryCurrency={
                                    universityProfileData?.countryCurrency
                                  }
                                />
                              </Grid>
                            ))}
                          </Grid>

                          {totalCourseCounted > 8 && (
                            <div className={styles.btn_wrapper}>
                              <Link
                                legacyBehavior
                                href={`/study/${query.country_name}/university/${query.university_name}/courses?${slugLink}`}
                              >
                                <a className="btn btn-secondary btn-bg">
                                  View {totalCourseCounted * 1 - 8} more{" "}
                                  {totalCourseCounted * 1 - 8 > 1
                                    ? "courses"
                                    : "course"}
                                </a>
                              </Link>
                            </div>
                          )}
                        </TabPanel>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <></>
      )}
    </Fragment>
  );
};

export default UniOverviewCourses;
